import React from "react";
import CarErecursos from "./CarErecursos";

const GuiasTematicasCollapse = ({ guias, guiasTitulo, carnet }) => {

    return (
        <div className="accordion" id="accordionExample">

            {
                guiasTitulo.map((data, key) => {
                    let idItem = '#collapse' + key;
                    let itemId = 'collapse' + key;
                    let itemHead = 'heading' + key;
                    return (
                        <div className="card" key={itemId}>
                            <div className="card-header" id={itemHead}>
                                <h2 className="mb-0">
                                    <button className="btn btn-link btn-block text-left collapsed" type="button" data-toggle="collapse" data-target={idItem} aria-expanded="true" aria-controls={itemId}>
                                        <i className="fa fa-map-signs mr-2" aria-hidden="true"></i>
                                        {data}
                                    </button>
                                </h2>
                            </div>

                            <div id={itemId} className="collapse" aria-labelledby={itemHead} data-parent="#accordionExample">
                                <div className="card-body">
                                    {
                                        guias
                                            ?
                                            <div className="esen-resource-grid">
                                                {
                                                    guias[key].map((recurso) => {
                                                        recurso.guiasTematicas = [];
                                                        return (
                                                            <CarErecursos
                                                                key={recurso.prefijoid}
                                                                recurso={recurso}
                                                                carnet={carnet}
                                                            />
                                                        )
                                                    })
                                                }
                                            </div>
                                            :
                                            null
                                    }
                                </div>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
};

export default GuiasTematicasCollapse;
